import queryString from 'query-string'

import { RequestService } from 'services/request.service'

import {
  CustomCard,
  CustomCardListResponse,
  CustomCardListQueryOptions,
  CustomCardCreateResponse,
} from 'services/apiTypes/customCards.types'
import { fixDangjosStupidFuckingInternalProtocolIssue } from './card.service'

// prettier-ignore
const NO_AUTH_ERROR = 'Unable to create Custom Card without auth. Try logging out and back in to reset your authentication'

export class CustomCardService extends RequestService {
  create = async (card: CustomCard): Promise<CustomCard> => {
    const userId = this.cookies.get('tbId')

    if (!userId) Promise.reject(NO_AUTH_ERROR)

    return super
      .post<CustomCardCreateResponse>(`/api/decks/customCards/`, {
        customCards: [defaultifyCustomCardBody(card, userId)],
      })
      .then(res => res.customCards[0])
  }

  bulkCreate = async (cards: CustomCard[]): Promise<CustomCard[]> => {
    const userId = this.cookies.get('tbId')

    if (!userId) Promise.reject(NO_AUTH_ERROR)

    return super
      .post<CustomCardCreateResponse>(`/api/decks/customCards/`, {
        customCards: cards.map(card => defaultifyCustomCardBody(card, userId)),
      })
      .then(res => res.customCards)
  }

  list = async (options: CustomCardListQueryOptions = {}, nextUrl?: string): Promise<CustomCardListResponse> => {
    if (nextUrl) return super.get<CustomCardListResponse>(nextUrl)

    const res = await super.get<CustomCardListResponse>(`/api/decks/customCards/?${queryString.stringify(options)}`)

    return {
      count: res.count,
      next: fixDangjosStupidFuckingInternalProtocolIssue(res.next),
      previous: fixDangjosStupidFuckingInternalProtocolIssue(res.previous),
      results: res.results,
    }
  }

  update = async (card: CustomCard): Promise<CustomCard> => {
    const userId = this.cookies.get('tbId')

    if (!userId) Promise.reject(NO_AUTH_ERROR)

    return super.patch(`/api/decks/customCards/${card.id}/`, defaultifyCustomCardBody(card, userId))
  }

  remove = async (customCardId: number): Promise<void> => {
    return super.delete(`/api/decks/customCards/${customCardId}/`, {}, true)
  }
}

const customCardService = new CustomCardService()

export default customCardService

// Useful function for keeping the data clean. Force changes any empty strings to null values, forces all back information null if hasBack is false
const defaultifyCustomCardBody = (customCard: CustomCard, userId: number): CustomCard => {
  return {
    id: customCard.id,
    owner: userId,
    cmc: customCard.cmc || 0,

    frontName: customCard.frontName,
    frontManaCost: customCard.frontManaCost || null,
    frontText: customCard.frontText || null,
    frontPower: customCard.frontPower || null,
    frontToughness: customCard.frontToughness || null,
    frontLoyalty: customCard.frontLoyalty || null,
    frontTypes: customCard.frontTypes || null,
    frontSubTypes: customCard.frontSubTypes || null,
    frontSuperTypes: customCard.frontSuperTypes || null,
    frontImageUrl: customCard.frontImageUrl || null,
    frontArtistName: customCard.frontArtistName || null,

    hasBack: customCard.hasBack || false,

    backName: !customCard.hasBack ? null : customCard.backName || null,
    backManaCost: !customCard.hasBack ? null : customCard.backManaCost || null,
    backText: !customCard.hasBack ? null : customCard.backText || null,
    backPower: !customCard.hasBack ? null : customCard.backPower || null,
    backToughness: !customCard.hasBack ? null : customCard.backToughness || null,
    backLoyalty: !customCard.hasBack ? null : customCard.backLoyalty || null,
    backTypes: !customCard.hasBack ? null : customCard.backTypes || null,
    backSubTypes: !customCard.hasBack ? null : customCard.backSubTypes || null,
    backSuperTypes: !customCard.hasBack ? null : customCard.backSuperTypes || null,
    backImageUrl: !customCard.hasBack ? null : customCard.backImageUrl || null,
    backArtistName: !customCard.hasBack ? null : customCard.backArtistName || null,

    setCode: customCard.setCode || null,
    collectorNumber: customCard.collectorNumber || null,
  }
}
